import { render, staticRenderFns } from "./SidebarPreview.vue?vue&type=template&id=7e0c4c4a"
import script from "./SidebarPreview.vue?vue&type=script&lang=js"
export * from "./SidebarPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports